<!-- Modal Overlay -->
<div class="modal-overlay" *ngIf="isVisible" (click)="fecharModal()">
  <div class="modal-container modal-large" (click)="$event.stopPropagation()">
    
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        <i class="fas fa-user"></i>
        Detalhes do Cliente
      </h2>
      <button type="button" class="btn-close" (click)="fecharModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body" *ngIf="clienteDetalhes">
      
      <!-- Dados Pessoais -->
      <div class="info-section">
        <h3 class="section-title">
          <i class="fas fa-user-circle"></i>
          Dados Pessoais
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label>Nome Completo:</label>
            <span>{{ clienteDetalhes.nome || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Email:</label>
            <span>{{ clienteDetalhes.email || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>CPF:</label>
            <span>{{ clienteDetalhes.cpf || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Senha:</label>
            <span>{{ clienteDetalhes.senha ? '••••••••' : 'Não informado' }}</span>
          </div>
        </div>
      </div>

      <!-- Contatos -->
      <div class="info-section">
        <h3 class="section-title">
          <i class="fas fa-phone"></i>
          Contatos
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label>Telefone Celular:</label>
            <span>{{ formatarTelefone(clienteDetalhes.telefone_celular) }}</span>
          </div>
          <div class="info-item">
            <label>Telefone Adicional:</label>
            <span>{{ formatarTelefone(clienteDetalhes.telefone_adicional) }}</span>
          </div>
        </div>
      </div>

      <!-- Endereço -->
      <div class="info-section">
        <h3 class="section-title">
          <i class="fas fa-map-marker-alt"></i>
          Endereço
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label>Rua:</label>
            <span>{{ clienteDetalhes.rua || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Número:</label>
            <span>{{ clienteDetalhes.numero || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Complemento:</label>
            <span>{{ clienteDetalhes.complemento || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Bairro:</label>
            <span>{{ clienteDetalhes.bairro || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>CEP:</label>
            <span>{{ clienteDetalhes.cep || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Cidade:</label>
            <span>{{ clienteDetalhes.cidade || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>Estado:</label>
            <span>{{ clienteDetalhes.estado || 'Não informado' }}</span>
          </div>
          <div class="info-item">
            <label>País:</label>
            <span>{{ clienteDetalhes.pais || 'Não informado' }}</span>
          </div>
        </div>
      </div>


      <!-- Informações Adicionais -->
      <div class="info-section">
        <h3 class="section-title">
          <i class="fas fa-info-circle"></i>
          Informações Adicionais
        </h3>
        <div class="info-grid">
          <div class="info-item" *ngIf="clienteDetalhes.link_pasta">
            <label>Link Pasta Virtual:</label>
            <span>
              <a [href]="clienteDetalhes.link_pasta" target="_blank" class="link-externo">
                {{ clienteDetalhes.link_pasta }}
                <i class="fas fa-external-link-alt"></i>
              </a>
            </span>
          </div>
          <div class="info-item">
            <label>Pasta Física:</label>
            <span>{{ formatarBoolean(clienteDetalhes.pasta_fisica) }}</span>
          </div>
          <div class="info-item full-width" *ngIf="clienteDetalhes.observacoes">
            <label>Observações:</label>
            <span class="observacoes">{{ clienteDetalhes.observacoes }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="fecharModal()">
        <i class="fas fa-times"></i> Fechar
      </button>
    </div>
  </div>
</div>
